<form [formGroup]="MerchantFormGroup">

  <div class="row form-horizontal">
    <div class="col-md-6 form-horizontal px-3">
      <div class="form-group row">
        <div class="col-12">
          <br />
          <b style="color: #477c93; font-size: 16px"> Merchant details</b>
        </div>
      </div>
    </div>
    <div class="col-md-6 form-horizontal px-3">
      <div class="form-group row">
        <label for="shopName" class="col-4 col-form-label">Merchant type indicator:</label>
        <div class="col-8">
          <ng-select2 id="merchantTypeIndicator" formControlName="merchantTypeIndicator" [data]="merchantTypesIndicator" (valueChanged)="onChangeMerchantTypeIndicator($event)" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.MerchantFormGroup.controls['merchantTypeIndicator'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['merchantTypeIndicator'].hasError('required')" class="parsley-required">Merchant type indicator is required.</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-md-12 form-horizontal px-3">
      <div>
        <div class="-divider dropdown-divider" style="border: 1px solid #348cd4"></div>
        <br />
      </div>
    </div>
  </div>

  <div class="row form-horizontal">
    <div class="col-md-6 form-horizontal px-3">

      <div class="form-group row">
        <label for="shopName" class="col-4 col-form-label">Shop Name</label>
        <div class="col-8">
          <input formControlName="shopName" (keypress)="omitSpecialChar($event)" class="form-control" id="shopName" placeholder="Shop name" maxlength="23">
          <ul *ngIf="this.MerchantFormGroup.controls['shopName'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['shopName'].hasError('required')" class="parsley-required">Shop name is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="merchantNumber" class="col-4 col-form-label">Merchant Number</label>
        <div [(class)]="col7isExistingMerchant">
          <input formControlName="merchantNumber" id="merchantNumber" placeholder="Merchant number" required class="form-control" maxlength="15">
          <ul *ngIf="submitted || displayMerchantIndicatorError || this.MerchantFormGroup.controls['merchantNumber'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['merchantNumber'].hasError('required')" class="parsley-required">Merchant number is required.</li>
            <li *ngIf="this.MerchantFormGroup.controls['merchantNumber'].hasError('minlength')" class="parsley-error">Merchant number must be atleast 15 characters.</li>
          </ul>
          <ul *ngIf="displayMerchantIndicatorError" class="parsley-errors-list filled">
            <li *ngIf="displayMerchantIndicatorError" class="parsley-error">{{merchantDoesNotExistMessage}}</li>
          </ul>
        </div>
        <div [(class)]="col1isExistingMerchant" *ngIf="isExistingMerchant">
          <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="searchMerchant()"> <i class="mdi mdi-search-web"></i> </button>
        </div>
      </div>

      <div class="form-group row">
        <label for="cardAcceptorConfig" class="col-4 col-form-label">Merchant config</label>
        <div class="col-8">
          <ng-select2 id="cardAcceptorConfigId" formControlName="cardAcceptorConfigId" [data]="cardAcceptorConfig" [options]="select2options" (valueChanged)="onMerchantConfig()" style="width:100%;"></ng-select2>
          <ul *ngIf="submitted || this.MerchantFormGroup.controls['cardAcceptorConfigId'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['cardAcceptorConfigId'].hasError('required')" class="parsley-required">Merchant config is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="cardSet" class="col-4 col-form-label">Card Set</label>
        <div class="col-8">
          <ng-select2 id="cardSet" formControlName="cardSet" [data]="cardSets" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.MerchantFormGroup.controls['cardSet'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['cardSet'].hasError('required')" class="parsley-required">Card set is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="isGovernmentalMerchant" class="col-4 col-form-label">Are you a governmental merchant?</label>
        <div class="col-8">
          <ng-select2 id="isGovernmentalMerchant" formControlName="isGovernmentalMerchant" [data]="governmentalOptions" [options]="select2options" (ngModelChange)="isGovernmental()"></ng-select2>
        </div>
      </div>

      <div class="form-group row" *ngIf="displayCountryCode">
        <label for="countryCurrencyCode" class="col-4 col-form-label">Country code</label>
        <div class="col-8">
          <input type="text" value="{{ countryCurrencyCode }}" class="form-control" id="countryCurrencyCode" maxlength="3"  [attr.disabled]="isExistingMerchant ? true : null">
        </div>
      </div>

      <div class="form-group row">
        <label for="countryCode" class="col-4 col-form-label">Country</label>
        <div class="col-8">
          <ng-select2 id="countryCode" formControlName="countryCode" [data]="countries" (valueChanged)="onChangeCountry($event)" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.MerchantFormGroup.controls['countryCode'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['countryCode'].hasError('required')" class="parsley-required">Country is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="regionCode" class="col-4 col-form-label">Region</label>
        <div class="col-8">
          <ng-select2 id="regionCode" formControlName="regionCode" [data]="regions" (valueChanged)="loadAreas($event)" [options]="select2options"></ng-select2>
          <ul *ngIf="submitted || this.MerchantFormGroup.controls['regionCode'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['regionCode'].hasError('required')" class="parsley-required">Region is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="city" class="col-4 col-form-label">City</label>
        <div class="col-8">
          <ng-select [items]="areaData" [virtualScroll]="true" [loading]="loading" bindLabel="Area" placeholder="Select City"
                     appendTo="body" [(ngModel)]="selectedArea" name="city" (ngModelChange)="onChangeCity(selectedArea)"
                     (scroll)="onScroll($event)" (scrollToEnd)="onScrollToEnd()" formControlName="city">
            <ng-template ng-header-tmp>
              <small class="form-text text-muted">Loaded {{areaBuffer.length}} of {{areas.length}}</small>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <span>{{item.Area}} - {{item.Suburb}} (<span><b>{{item.StrCode}}</b></span><span *ngIf="item.StrCode == null"><b>{{item.BoxCode}}</b></span>)</span>
            </ng-template>
          </ng-select>
          <ul *ngIf="submitted || this.MerchantFormGroup.controls['city'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['city'].hasError('required')" class="parsley-required">City is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="town" class="col-4 col-form-label">Town</label>
        <div class="col-8">
          <input formControlName="town"
                 id="town"
                 class="form-control"
                 placeholder="Town">
        </div>
      </div>

      <div class="form-group row">
        <label for="postalServiceCode" class="col-4 col-form-label">Postal Service Code</label>
        <div class="col-8">
          <input formControlName="postalServiceCode" id="postalServiceCode" class="form-control" maxlength="4" placeholder="Postal code">
          <ul *ngIf="submitted || this.MerchantFormGroup.controls['postalServiceCode'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['postalServiceCode'].hasError('required')" class="parsley-required">Postal service code is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="merchantType" class="col-4 col-form-label">Merchant Type <i class="fe-info" placement="top" ngbTooltip="Also known as MMC"></i></label>
        <div class="col-8">
          <ng-select2 id="merchantType" formControlName="merchantType" [data]="merchantTypes" [options]="select2options" (ngModelChange)="onChangeMerchantType($event)"></ng-select2>
          <ul *ngIf="submitted || this.MerchantFormGroup.controls['merchantType'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['merchantType'].hasError('required')" class="parsley-required">Merchant type is required.</li>
          </ul>
        </div>
      </div>

    </div>
    <div class="col-md-6 form-horizontal px-3">

      <div class="form-group row" *ngIf="display.subMerchantId">
        <label for="subMerchantId" class="col-4 col-form-label">Sub Merchant ID<i class="fe-info" placement="top" ngbTooltip="Client facing Merchant number for aggregator merchants, Please populate with 15 zeros for ISO merchants"></i></label>
        <div class="col-8">
          <input formControlName="subMerchantId" id="subMerchantId" class="form-control" maxlength="15" placeholder="">
          <ul *ngIf="submitted || displayIsoContentError || this.MerchantFormGroup.controls['subMerchantId'].dirty || this.MerchantFormGroup.controls['subMerchantId'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['subMerchantId'].value == ''" class="parsley-required">Sub Merchant ID is required.</li>
            <li *ngIf="this.MerchantFormGroup.controls['subMerchantId'].hasError('minlength')" class="parsley-error">Sub Merchant Id must be atleast 15 characters.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row" *ngIf="display.paymentFacilitatorId">
        <label for="paymentFacilitatorId" class="col-4 col-form-label">Payment Facilitator ID<i class="fe-info" placement="top" ngbTooltip="PFID provided by bank when Aggregator after registered with VISA/MC"></i></label>
        <div class="col-8">
          <input formControlName="paymentFacilitatorId" id="paymentFacilitatorId" class="form-control" maxlength="11" placeholder="">
          <ul *ngIf="submitted || displayIsoContentError || this.MerchantFormGroup.controls['paymentFacilitatorId'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['paymentFacilitatorId'].value == ''" class="parsley-required">Payment Facilitator ID is required.</li>
          </ul>
        </div>

      </div>

      <div class="form-group row" *ngIf="display.paymentFacilitatorIdVisa">
        <label for="paymentFacilitatorIdVisa" class="col-4 col-form-label">Payment Facilitator ID VISA</label>
        <div class="col-8">
          <input formControlName="paymentFacilitatorIdVisa" id="paymentFacilitatorIdVisa" class="form-control" maxlength="11" placeholder="">
          <ul *ngIf="submitted || displayIsoContentError || this.MerchantFormGroup.controls['paymentFacilitatorIdVisa'].dirty || this.MerchantFormGroup.controls['paymentFacilitatorIdVisa'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['paymentFacilitatorIdVisa'].value == ''" class="parsley-required">Payment Facilitator ID VISA is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row" *ngIf="display.independentSalesOrgId">
        <label for="independentSalesOrgId" class="col-4 col-form-label">Independent Sales Organization ID   <i class="fe-info" placement="top" ngbTooltip="For ISO Merchants only this field should be populated with the same value as the Mastercard Payments Facilitator Details"></i></label>
        <div class="col-8">
          <input formControlName="independentSalesOrgId" id="independentSalesOrgId" class="form-control" maxlength="11" placeholder="">
          <ul *ngIf="submitted || this.MerchantFormGroup.controls['independentSalesOrgId'].dirty || this.MerchantFormGroup.controls['independentSalesOrgId'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['independentSalesOrgId'].value == ''" class="parsley-required">Independent Sales Organization ID is required.</li>
            <li *ngIf="this.MerchantFormGroup.controls['independentSalesOrgId'].hasError('minlength')" class="parsley-error">Independent Sales Organization ID must be atleast 11 characters.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row" *ngIf="display.independentSalesOrgIdVisa">
        <label for="independentSalesOrgIdVisa" class="col-4 col-form-label">Independent Sales Organization ID VISA </label>
        <div class="col-8">
          <input formControlName="independentSalesOrgIdVisa" id="independentSalesOrgIdVisa" class="form-control" maxlength="11" placeholder="">
          <ul *ngIf="submitted || displayIsoContentError || this.MerchantFormGroup.controls['independentSalesOrgIdVisa'].dirty || this.MerchantFormGroup.controls['independentSalesOrgIdVisa'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['independentSalesOrgIdVisa'].value == ''" class="parsley-required">Independent Sales Organization ID VISA is required.</li>
            <li *ngIf="this.MerchantFormGroup.controls['independentSalesOrgIdVisa'].hasError('minlength')" class="parsley-error">Independent Sales Organization ID VISA must be atleast 11 characters.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row" *ngIf="display.customerServicePhoneNo">
        <label for="customerServicePhoneNo" class="col-4 col-form-label">Customer Service Phone No <i class="fe-info" placement="top" ngbTooltip="Customer Service Phone Number should start with '27' i.e 27721234567"></i></label>
        <div class="col-8">
          <input formControlName="customerServicePhoneNo" id="customerServicePhoneNo" class="form-control" minlength="11" maxlength="11" placeholder="">
          <ul *ngIf="submitted || displayIsoContentError || this.MerchantFormGroup.controls['customerServicePhoneNo'].dirty || this.MerchantFormGroup.controls['customerServicePhoneNo'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['customerServicePhoneNo'].value == ''" class="parsley-required">Customer Service Phone No is required.</li>
            <li *ngIf="this.MerchantFormGroup.controls['customerServicePhoneNo'].hasError('minlength')" class="parsley-error">Customer Service Phone No must be atleast 11 characters.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row" *ngIf="display.merchantStreetAddress">
        <label for="merchantStreetAddress" class="col-4 col-form-label">Delivery Address   <i class="fe-info" placement="top" ngbTooltip="48 characters and space-filled. No special Characters such as '"></i></label>
        <div class="col-8">
          <textarea rows="3" (keypress)="omitSpecialCharAddress($event)" formControlName="merchantStreetAddress" class="form-control" id="merchantStreetAddress" placeholder="Street Address"></textarea>
          <ul *ngIf=" submitted || displayIsoContentError || this.MerchantFormGroup.controls['merchantStreetAddress'].dirty || this.MerchantFormGroup.controls['merchantStreetAddress'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['merchantStreetAddress'].value == ''" class="parsley-required">Street Address is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row" *ngIf="display.merchantVerificationValue">
        <label for="merchantVerificationValue" class="col-4 col-form-label">Merchant Verification Value  <i class="fe-info" placement="top"></i></label>
        <div class="col-8">
          <input formControlName="merchantVerificationValue" id="merchantVerificationValue" class="form-control" maxlength="10" placeholder="">
          <ul *ngIf="submitted || displayIsoContentError || this.MerchantFormGroup.controls['merchantVerificationValue'].dirty || this.MerchantFormGroup.controls['merchantVerificationValue'].touched" class="parsley-errors-list filled">
            <li *ngIf="this.MerchantFormGroup.controls['merchantVerificationValue'].value == ''" class="parsley-required">Merchant Verification Value is required.</li>
            <li *ngIf="this.MerchantFormGroup.controls['merchantVerificationValue'].hasError('minlength')" class="parsley-error">Merchant Verification Value must be atleast 10 characters.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="slipHeader" class="col-4 col-form-label">Slip Header <i class="fe-info" placement="top" ngbTooltip="Header info may differ on slip/paper from the website. limits could be due to slip/paper width or OS limitations"></i></label>
        <div class="col-8">
          <textarea rows="4" cols="24" formControlName="slipHeader" class="form-control" id="slipHeader" placeholder="Slip header" (input)="onSlipHeaderChange($event.target.value)"></textarea>
        </div>
      </div>

      <div class="form-group row">
        <label for="slipTrailer" class="col-4 col-form-label">Slip Trailer <i class="fe-info" placement="top" ngbTooltip="Trailer info may differ on slip/paper from the website. limits could be due to slip/paper width or OS limitations"></i></label>
        <div class="col-8">
          <textarea rows="4" cols="24" formControlName="slipTrailer" class="form-control" id="slipTrailer" placeholder="Slip trailer" (input)="onSlipTrailerChange($event.target.value)"></textarea>
        </div>
      </div>

      <div class="form-group row">
        <label for="notes" class="col-4 col-form-label">Notes </label>
        <div class="col-8">
          <textarea rows="4" formControlName="notes" class="form-control" id="notes" placeholder="Notes" (ngModelChange)="onNotesChange($event)"></textarea>
        </div>
      </div>

    </div>
  </div>

</form>


